import getSelectedTableView from '../../utils/getSelectedTableView';
import { action } from 'satcheljs/lib/legacy';

export default action('unselectAll')(function unselectAll() {
    const tableView = getSelectedTableView();
    tableView.isInVirtualSelectAllMode = false;
    tableView.virutalSelectAllExclusionList = [];
    tableView.selectedItemsIds.clear();
});
